
const table = JSON.parse(document.querySelector("#translations")?.textContent ?? "{}");

/**
 * A string template processor that looks up and returns translations for the specified string.
 *
 * <pre>
 *     tr`Wind`  // "Vent"
 * </pre>
 *
 * @param {string[]} parts
 * @returns {string} the translated string
 */
export function tr(parts) {
    if (parts.length > 1) {
        throw new Error("NYI");  // substitutions not supported
    }
    const key = parts[0];
    return table[key] ?? key;
}
